import { Component } from '@angular/core';

@Component({
    selector: 'cp-page-notfound',
    templateUrl: './page-notfound.component.html',
    styleUrls: ['./page-notfound.component.css'],
    standalone: false
})
export class PageNotfoundComponent {

}
